export const SCROLLER_SELECTOR = '.MuiTabs-scroller';
export const TAB_SELECTOR = '.MuiTab-root';
export const SCROLL_POSITION_EPSILON = 1;
export const MUI_SCROLL_ANIMATION_DURATION = 300;
export const TAB_SELECTION_DELAY = MUI_SCROLL_ANIMATION_DURATION + 50;
export const INDICATOR_UPDATE_DELAY = 500;

export const clamp = (value: number, min: number, max: number) =>
  Math.max(min, Math.min(value, max));

export const smoothScrollTo = (element: HTMLElement, left: number) => {
  if (typeof element.scrollTo === 'function') {
    element.scrollTo({ left, behavior: 'smooth' });
    return;
  }

  element.scrollLeft = left;
};

export const getTabA11yProps = (index: number) => ({
  id: `tab-${index}`,
  'aria-controls': `tabpanel-${index}`,
});
